import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import InfoBannerButtons from './InfoBannerButtons';

const InfoBanner = ({
  form,
  user,
  onClickAddFormDetails,
  onSendPacketSuccess,
}) => (
  <Box
    row={form.get('is_submitted')}
    column={!form.get('is_submitted')}
    grow
    basis={0}
    vcenter
    spacebetween
  >
    <InfoBannerButtons
      form={form}
      user={user}
      onClickAddFormDetails={onClickAddFormDetails}
      onSendPacketSuccess={onSendPacketSuccess}
    />
  </Box>
);

InfoBanner.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  form: ImmutablePropTypes.map.isRequired,
  onClickAddFormDetails: PropTypes.func.isRequired,
};

export default InfoBanner;
